export default __webpack_public_path__ + "static/media/avatarC3.5dbd7418.png";